import React from 'react';
import { Field, Checkbox } from '../../../../Core';
import { ListFieldSection } from '../../../../Layout';
import { withInjectedProps } from '../../../../Core/InjectedPropsContext';
import { useSelector } from 'react-redux';
import { IWorksheetComponent } from 'Components/Worksheets/Core/types';
import { CwdChartSection } from '../../Shared';

let AsCompactionCwdSection: React.FC<IWorksheetComponent> = ({ createWorksheetSelector }) => {
  const enterConvertedWetDensity =
    useSelector(createWorksheetSelector!('Preparation.EnterConvertedWetDensity')) ?? false;

  return (
    <>
      <ListFieldSection>
        <Field input={<Checkbox />} name="Preparation.EnterConvertedWetDensity" />
      </ListFieldSection>
      {enterConvertedWetDensity && <CwdChartSection />}
    </>
  );
};

AsCompactionCwdSection = withInjectedProps(AsCompactionCwdSection);

export { AsCompactionCwdSection };
export default AsCompactionCwdSection;
